// GA4 conversion events — delegated click listener (PAGE_PLAYBOOK / FUNNEL-AND-ANALYTICS-MAP §4)
// Reads data-ga-* attributes from any clicked CTA and forwards them to gtag.
// Canonical data-ga-event values: install_click, demo_click, calculator_click,
// live_demo_click, contact_click, pricing_click, newsletter — never invent per-page variants.

export function analytics() {
    document.addEventListener('click', (e) => {
        const el = e.target.closest('[data-ga-event]');
        if (!el) return;

        trackEvent(el.dataset.gaEvent, {
            event_category: el.dataset.gaCategory,
            event_section: el.dataset.gaSection,
            event_label: el.dataset.gaLabel,
            cta_temp: el.dataset.gaTemp,
            seg: el.dataset.gaSeg,
            vertical: el.dataset.gaVertical,
        });
    });
}

// Shared helper for explicit (non-click) events: form_submit, subscribe, vote_cast, etc.
export function trackEvent(eventName, params = {}) {
    if (!eventName || typeof gtag !== 'function') return;

    const payload = { page_slug: window.location.pathname };
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') payload[key] = value;
    });

    try {
        gtag('event', eventName, payload);
    } catch (err) {
        console.warn('[CPB:analytics] gtag event failed', eventName, err);
    }
}
